import React from 'react';
import { Container } from 'reactstrap';
import { DashboardPageHeader, ComingSoonCard } from '../../Components/Common/DashboardKit';

/**
 * Planning module landing page.
 *
 * UI-only refactor (Pass 1): swapped video <ComingSoon> for the
 * flat <ComingSoonCard>; removed unused imports. Route is wrapped
 * in <RoleProtected requireManager> in allRoutes.js.
 */
const Planning = () => {
    document.title = "SSW Technologies Dashboard";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-calendar-todo-line"
                        eyebrow="Operations"
                        title="Planning"
                        subtitle="Schedules, capacity, and forecasts"
                        tone="blue"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Planning" },
                        ]}
                    />

                    <ComingSoonCard
                        icon="ri-calendar-todo-line"
                        title="Planning tools are coming soon"
                        message="Capacity planning, schedule forecasts, and load views are being built. Continue using the existing planning spreadsheets for now."
                        tone="info"
                        features={[
                            "Weekly capacity forecast",
                            "Machine load views",
                            "Schedule vs actual reports",
                            "Demand planning inputs",
                        ]}
                        contact="Reach out to the Planning team for ETA updates."
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Planning;
